export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8015.9dd3c6b0.jpg";